import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { Router } from '@angular/router';
import { entAnimations } from 'src/app/animations';
import { UserInfo } from 'src/app/models/user-info.model';
import { KeycloakService } from 'src/app/services/keycloak/keycloak.service';
import { UsersService } from 'src/app/services/users/users.service';
import { Error } from 'src/app/models/error.model';
import { lastValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CustomValidators } from 'src/app/utils/validators';
import { LocalStorageService } from 'src/app/services/localStorage/localStorage.service';
import { UserNameChange } from 'src/app/models/user-name-change.model';

@Component({
  selector: 'app-name-change',
  templateUrl: './name-change.component.html',
  styleUrl: './name-change.component.scss',
  encapsulation: ViewEncapsulation.None,
  animations: entAnimations,
  standalone: false,
})
export class NameChangeComponent implements OnInit {
  // API Calls
  userOid: string;
  isLoading = false;
  isLoadingName = false;
  isStudent = false;

  selectedUser: UserInfo = new UserInfo();
  errorUpdate = false;
  isErrorUpdateName = false;
  isBusy = false;
  isBusyUpdateName = false;
  errorUpdateName: Error = { error: { message: '', code: '' } };

  spinner = {
    color: 'primary',
    mode: 'indeterminate' as ProgressSpinnerMode,
    value: 50,
    diameter: 50,
  };

  // Change Name
  changenameForm: FormGroup;
  hasMultipleFirstName: boolean;
  hasMultipleLastName: boolean;
  userAccountname = 'martin.tazlari';
  isNameUpdated = false;
  canChangeName = false;
  canChangeNameStd = false;

  // Pwd
  timeLeft = 60;
  interval: NodeJS.Timeout;

  // Access to CanChangeName
  UserCanChangeName = false;
  errorAccess = false;

  constructor(
    private _userService: UsersService,
    private _formBuilder: FormBuilder,
    private _router: Router,
    private _keycloakService: KeycloakService,
    private _localStorageService: LocalStorageService
  ) {}

  ngOnInit() {
    this.isLoading = false;
    this.isBusy = false;
    this.canChangeName = false;
    this.canChangeNameStd = false;

    this.getUser().then(() => {
      if (
        this.selectedUser.canChangeName ||
        this.selectedUser.canChangeNameStd
      ) {
        this.canChangeName = this.selectedUser.canChangeName;
        this.canChangeNameStd = this.selectedUser.canChangeNameStd;
        this.nameUpdate();
      }
    });

    this.changenameForm = this._formBuilder.group({
      officialFirstName: [{ value: '', disabled: true }],
      officialLastName: [{ value: '', disabled: true }],
      firstName: [''],
      lastName: [''],
      eduvsLogin: [{ value: '', disabled: true }],
      eduvsMail: [{ value: '', disabled: true }],
      hasValidate: [false],
    });

    this.setDefaultValue();
  }

  setDefaultValue(): void {
    // Change Name Default Value

    this.changenameForm
      .get('officialFirstName')
      .setValue(this.selectedUser.officialFirstName);
    this.changenameForm
      .get('officialLastName')
      .setValue(this.selectedUser.officialLastName);
    this.changenameForm.get('firstName').setValue(this.selectedUser.firstName);
    this.changenameForm.get('lastName').setValue(this.selectedUser.lastName);
    this.generateNewUserLogin();

    // Check Multiple Name
    if (!this.selectedUser.canChangeNameStd) {
      if (this.selectedUser.officialFirstName.indexOf(' ') === -1) {
        if (this.selectedUser.officialFirstName.indexOf('-') > 0) {
          this.hasMultipleFirstName = true;
          this.changenameForm.get('firstName').setValue('');
          this.changenameForm
            .get('firstName')
            .setValidators([
              Validators.required,
              CustomValidators.nameValidator(
                this.selectedUser.officialFirstName
              ),
            ]);
        } else {
          this.hasMultipleFirstName = false;
          this.changenameForm.get('firstName').disable();
          this.changenameForm
            .get('firstName')
            .setValidators(Validators.required);
        }
      } else {
        this.hasMultipleFirstName = true;
        this.changenameForm.get('firstName').setValue('');
        this.changenameForm
          .get('firstName')
          .setValidators([
            Validators.required,
            CustomValidators.nameValidator(this.selectedUser.officialFirstName),
          ]);
      }

      if (this.selectedUser.officialLastName.indexOf(' ') === -1) {
        if (this.selectedUser.officialLastName.indexOf('-') > 0) {
          this.hasMultipleLastName = true;
          this.changenameForm.get('lastName').setValue('');
          this.changenameForm
            .get('lastName')
            .setValidators([
              Validators.required,
              CustomValidators.nameValidator(
                this.selectedUser.officialLastName
              ),
            ]);
        } else {
          this.hasMultipleLastName = false;
          this.changenameForm.get('lastName').disable();
          this.changenameForm
            .get('lastName')
            .setValidators(Validators.required);
        }
      } else {
        this.hasMultipleLastName = true;
        this.changenameForm.get('lastName').setValue('');
        this.changenameForm
          .get('lastName')
          .setValidators([
            Validators.required,
            CustomValidators.nameValidator(this.selectedUser.officialLastName),
          ]);
      }
    } else {
      this.hasMultipleFirstName = false;
      this.changenameForm.get('firstName').disable();
      this.changenameForm.get('firstName').setValidators(Validators.required);

      this.hasMultipleLastName = false;
      this.changenameForm.get('lastName').disable();
      this.changenameForm.get('lastName').setValidators(Validators.required);
    }
  }

  //Logout button
  logout(): void {
    this._userService.clearStorageAndLogout();
    this._keycloakService.logout(environment.logoutURL);
    this._keycloakService.clearToken();
  }

  startTimer() {
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        this._userService.emptyStorage();
        this._keycloakService.logout(environment.logoutURL);
        this._keycloakService.clearToken();
      }
    }, 1000);
  }

  fetchNameFormData(): UserNameChange {
    return {
      firstName: CustomValidators.capitalizeFirstLetter(
        this.changenameForm.get('firstName').value
      ),
      lastName: CustomValidators.capitalizeFirstLetter(
        this.changenameForm.get('lastName').value
      ),
    };
  }

  async changeName(): Promise<void> {
    // Reset all errors and boolean in case of multiple error
    this.isBusy = false;
    this.errorUpdate = false;
    this.errorUpdateName = { error: { message: '', code: '' } };
    this.isErrorUpdateName = false;
    this.isNameUpdated = false;

    try {
      const value = this.fetchNameFormData();
      this.isBusyUpdateName = true;
      await lastValueFrom(
        this._userService.changeName(this.selectedUser.oid, value)
      ).then(response => {
        const uservalidate = response;
        this.userAccountname = uservalidate.username;
        this.selectedUser.firstName = value.firstName;
        this.selectedUser.lastName = value.lastName;
        this.isNameUpdated = true;
        this._userService.userHasBeenUpdated(
          value.firstName,
          value.lastName,
          uservalidate.username + '@edu.vs.ch'
        );
        this.startTimer();
      });
    } catch (error) {
      let customError: Error = { error: undefined };

      if (error.statusText == 'Unknown Error') {
        customError = { error: { message: 'Unknown Error', code: 'ERR2' } };
      } else {
        if (error.error) {
          customError = error.error;
        }
        if (customError.error === undefined) {
          customError = { error: { message: 'Unknown Error', code: 'ERR2' } };
        }
      }
      this.isErrorUpdateName = true;
      this.errorUpdateName = customError;
      this.isNameUpdated = false;
    } finally {
      this.isBusyUpdateName = false;
    }
  }

  getNewUser(): UserInfo {
    const user = { ...this.selectedUser };
    user.firstName = this.changenameForm.get('firstName').value;
    user.lastName = this.changenameForm.get('lastName').value;
    return user;
  }

  async generateNewUserLogin() {
    const newUsername = await lastValueFrom(
      this._userService.getNewUsername(this.getNewUser())
    );
    this.changenameForm.get('eduvsLogin').setValue(newUsername);
    this.changenameForm.get('eduvsMail').setValue(newUsername + '@edu.vs.ch');
  }

  updateUserLoginForm() {
    if (this.changenameForm.valid) {
      this.generateNewUserLogin();
    }
  }

  async nameUpdate(): Promise<void> {
    this.errorAccess = false;
    this.isLoadingName = true;

    try {
      await lastValueFrom(this._userService.canChangeName(this.userOid)).then(
        () => {
          this.UserCanChangeName = true;
        }
      );
    } catch {
      this.errorAccess = true;
    } finally {
      this.isLoadingName = false;
    }
  }

  async getUser(): Promise<void> {
    try {
      this.isLoading = true;
      // NO User in Cache
      if (this._localStorageService.getItem('currentUser') === null) {
        this.selectedUser = await lastValueFrom(
          this._userService.getCurrentUser()
        );
      } else {
        this.selectedUser = this._userService.currentUserValue;
      }

      this.isLoading = false;
      this.userOid = this.selectedUser.oid;

      this.selectedUser.roles.forEach(element => {
        if (element.name.toLowerCase().includes('eleve')) {
          this.isStudent = true;
        }
      });
    } catch (error) {
      let customerError: Error = { error: undefined };
      if (error.statusText == 'Unknown Error') {
        customerError = { error: { message: 'Unknown Error', code: 'ERR2' } };
      } else {
        if (error.error) {
          customerError = error.error;
        }
        if (customerError.error !== undefined) {
          if (customerError.error.code == 'ERR403') {
            this._router.navigate(['/errors/error-403']);
          } else {
            this._router.navigate(['/errors/error-404']);
          }
        }
      }
    }
  }
}
